import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NewsletterFormComponent } from 'projects/app-default/src/app/newsletter/newsletter-form.component';

export interface IPageComponentNewsletterData {
    // source id
    source?: string;
    // custom success nessage
    successMessage?: string;
}

@Component({
    selector: 'page-component-newsletter',
    templateUrl: './newsletter.html',
    standalone: true,
    imports: [NewsletterFormComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentNewsletterComponent>({
    id: 'newsletter',
    name: 'Inline newsletter form',
    description: 'Component is optimised to work with footer',
    image: '/common/cms/newsletter-component.png',
    tags: ['newsletter', 'footer'],
    fields: [
        // general
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        {
            key: 'text',
            type: NICmsContentField.EFieldType.text,
            title: 'Success message'
        },
        {
            key: 'source',
            type: NICmsContentField.EFieldType.text,
            title: 'Source id for tracking'
        }
    ]
})
export class PageComponentNewsletterComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentNewsletterData;
}
